<script lang="ts" setup>
import Link6 from '@/components/Button/Link6.vue'

const lists = ref([
  {
    title: '業務開發',
    data: [
      '業績目標管理及營業通路銷售規劃',
      '開發潛在/核心通路客戶',
      '掌握商品銷售表現及市場反饋',
      '客戶關係維護與服務'
    ]
  },
  {
    title: '行銷企劃',
    data: [
      '品牌行銷活動規劃',
      '蒐集及分析市場資訊',
      '與原廠協作達成行銷目標',
      '結合各通路合作，推展品牌市佔度'
    ]
  },
  {
    title: '百貨銷售',
    data: [
      '強化客戶體驗與提供優質服務',
      '推動品牌商品銷售，達成專櫃業績目標',
      '協助商品售後服務'
    ]
  },
  {
    title: '維修服務',
    data: [
      '產品檢測、維修和故障排除',
      '專業技術支持及解答客戶疑問',
      '維修報告紀錄與彙整分析',
      '遵行售後服務規範，建立良好服務品質'
    ]
  }
])
</script>

<template>
  <section class="join">
    <div class="join__top">
      <Intro subtitle="join us" :data="{
        title: '常態職缺介紹'
      }" class="align-left display80" />
      <Link6 to="https://www.104.com.tw/company/18jbbhnk?jobsource=index_s_cs" linkTitle="投遞履歷" />
    </div>
    <ul class="join__lists">
      <li v-for="(item, index) in lists" :key="index">
        <div class="join__lists__item">
          <div class="join__lists__title">{{ item.title }}</div>
          <div class="join__lists__bottom">
            <div class="join__lists__text" v-for="(data, indexData) in item.data" :key="indexData">
              {{ data }}
            </div>
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>

<style lang="scss" scoped>
.join {
  &__top {
    margin-bottom: toRem(85);
  }

  &__lists {
    display: grid;
    grid-template-columns: repeat(auto-fill, calc((100% - 72px) / 4));
    column-gap: toRem(24);

    @include max-media(880) {
      grid-template-columns: repeat(auto-fill, calc((100% - 24px) / 2));
    }

    @include max-media(540) {
      grid-template-columns: repeat(auto-fill, 100%);
    }

    li {
      @include max-media(880) {
        margin-bottom: toRem(24);
      }

      &:nth-child(odd) {
        @include min-media(881) {
          margin-top: toRem(45);
        }

        .join {
          &__lists {
            &__item {
              background-color: $bg-1;
            }
          }
        }
      }

      &:nth-child(even) {
        .join {
          &__lists {
            &__item {
              background-color: $color-white-1;
            }

            &__title {
              color: $color-gray-1;
            }
          }
        }
      }
    }

    &__item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: toRem(40) toRem(32);

      @include min-media(541) {
        min-height: toRem(315);
      }

      @include max-media(540) {
        padding: toRem(24);
      }
    }

    &__title {
      font-size: toRem(22);
      font-weight: 500;
      line-height: 1.3;

      @include max-media(540) {
        font-size: toRem(16);
        margin-bottom: toRem(24);
        line-height: 1.6;
        font-weight: 700;
      }
    }

    &__text {
      position: relative;
      padding-left: toRem(12);
      color: $color-black-1;
      font-size: toRem(14);
      font-weight: 400;
      line-height: 1.3;

      &:not(:last-child) {
        margin-bottom: toRem(12);
      }

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: toRem(5);
        width: toRem(6);
        height: toRem(6);
        background-color: $color-brand-3;
      }
    }
  }
}
</style>
